module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"name":"Name","published":"Published","photosok":"Photos OK","edit-photos":"Edit photos","edit":"Edit simulation","publish":"Publish","unpublish":"Unpublish"},"fi":{"name":"Nimi","published":"Julkaistu","photosok":"Kuvat kunnossa","edit-photos":"Muokkaa kuvia","edit":"Muokkaa simulaatiota","publish":"Julkaise","unpublish":"Peru julkaisu"}}')
  delete Component.options._Ctor
}
